import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { ROUTINGDATA } from '../ROUTINGDATA';

// Centralized SEO configuration for each route path
const seoConfig = {
  // Home page
  [ROUTINGDATA.LAND]: {
    title: 'Tamil Nadu Jobs 2026 | Latest Job Vacancies in Chennai, Coimbatore, Madurai | VelaiVendum',
    description: 'Find the latest jobs in Tamil Nadu. Free job posting for new users. Employers can register to post jobs. Explore Chennai, Coimbatore, Madurai, Trichy and other cities. Apply for IT, Engineering, Freshers, Private and Government jobs on VelaiVendum.',
    keywords: 'Tamil Nadu Jobs, Jobs in Chennai, Tamil Jobs, Job Vacancies Tamil Nadu, Freshers Jobs, IT Jobs Chennai, Government Jobs Tamil Nadu, Walkin Jobs',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "VelaiVendum",
      "url": "https://www.velaivendum.com",
      "logo": "https://www.velaivendum.com/logo.png",
      "sameAs": [
        "https://www.facebook.com/VelaiVendum",
        "https://twitter.com/VelaiVendum",
        "https://www.linkedin.com/company/VelaiVendum"
      ]
    }
  },
  // Job listing page (example path, adjust as needed)
  [ROUTINGDATA.JOBPROVIDER]: {
    title: 'Tamil Nadu Job Listings | Browse Latest Vacancies | VelaiVendum',
    description: 'Browse the latest job listings across Tamil Nadu. Free job posting for new users. Employers can register to post jobs. Filter by city, sector, and experience level. Find your next career opportunity with VelaiVendum.',
    keywords: 'Tamil Nadu Jobs, Job Listings, IT Jobs Chennai, Engineering Jobs Tamil Nadu, Government Jobs Tamil Nadu',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "url": "https://www.velaivendum.com",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://www.velaivendum.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }
  },
  // Job detail page – generic fallback (dynamic ID will be handled by route param)
  '/job/detail': {
    title: 'Job Detail – Tamil Nadu Jobs | VelaiVendum',
    description: 'View detailed information about this job posting, including responsibilities, requirements, and application process. Free job posting for new users. Employer registration available.',
    keywords: 'Job Detail, Tamil Nadu Jobs, Apply Job',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {
      "@context": "https://schema.org",
      "@type": "JobPosting",
      "title": "Job Title Placeholder",
      "description": "Job description placeholder.",
      "datePosted": "2026-01-01",
      "employmentType": "FULL_TIME",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "VelaiVendum",
        "sameAs": "https://www.velaivendum.com"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "Tamil Nadu",
          "addressCountry": "IN"
        }
      }
    }
  },
  // Contact page (example)
  [ROUTINGDATA.LANDPAGECONTACTUS]: {
    title: 'Contact VelaiVendum – Tamil Nadu Job Portal',
    description: 'Get in touch with VelaiVendum for support, enquiries, or partnership opportunities. Free job posting for new users. Employers can register to post jobs.',
    keywords: 'Contact VelaiVendum, Tamil Nadu Jobs Support',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "url": "https://www.velaivendum.com/contact",
      "name": "Contact VelaiVendum"
    }
  },
  //Registration And Login
  [ROUTINGDATA.LOGIN]: {
    title: 'Login | VelaiVendum Tamil Nadu Job Portal',
    description: 'Login to VelaiVendum to apply for jobs, manage applications, and connect with employers across Tamil Nadu.',
    keywords: 'VelaiVendum Login, Job Portal Login, Tamil Nadu Jobs Login',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Login"
    }
  },

  [ROUTINGDATA.JOBSEEK]: {
    title: 'Job Seeker Registration | Tamil Nadu Jobs | VelaiVendum',
    description: 'Create a free Job Seeker account on VelaiVendum. Apply for jobs in Chennai, Coimbatore, Madurai, Trichy, Salem and across Tamil Nadu.',
    keywords: 'Job Seeker Registration, Tamil Nadu Jobs, Chennai Jobs, Freshers Jobs, Apply Jobs Online',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {
      "@context": "https://schema.org",
      "@type": "RegisterAction",
      "name": "Job Seeker Registration"
    }
  },
  // Generic pages
  [ROUTINGDATA.TERMSANDCONDITION]: {
    title: 'Terms and Conditions – VelaiVendum',
    description: 'Read the terms and conditions of using VelaiVendum. Free job posting for new users. Employers can register to post jobs.',
    keywords: 'terms, conditions, VelaiVendum',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {}
  },
  [ROUTINGDATA.PrivacyPolicy]: {
    title: 'Privacy Policy – VelaiVendum',
    description: 'Learn how VelaiVendum protects your privacy. Free job posting for new users. Employers can register to post jobs.',
    keywords: 'privacy, policy, VelaiVendum',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {}
  },
  [ROUTINGDATA.PurchasePolicy]: {
    title: 'Purchase Policy – VelaiVendum',
    description: 'Details about purchase policies on VelaiVendum. Free job posting for new users. Employers can register to post jobs.',
    keywords: 'purchase policy, VelaiVendum',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {}
  },
  [ROUTINGDATA.RefundPolicy]: {
    title: 'Refund Policy – VelaiVendum',
    description: 'Information on refunds for services on VelaiVendum. Free job posting for new users. Employers can register to post jobs.',
    keywords: 'refund policy, VelaiVendum',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {}
  },
  [ROUTINGDATA.DeliveryPolicy]: {
    title: 'Delivery Policy – VelaiVendum',
    description: 'How delivery works for services on VelaiVendum. Free job posting for new users. Employers can register to post jobs.',
    keywords: 'delivery policy, VelaiVendum',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {}
  },
  [ROUTINGDATA.PricingPolicy]: {
    title: 'Pricing Policy – VelaiVendum',
    description: 'Pricing details for VelaiVendum services. Free job posting for new users. Employers can register to post jobs.',
    keywords: 'pricing policy, VelaiVendum',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {}
  },
  [ROUTINGDATA.companies]: {
    title: 'Companies – VelaiVendum',
    description: 'List of companies posting jobs on VelaiVendum. Free job posting for new users. Employers can register to post jobs.',
    keywords: 'companies, employers, job postings, VelaiVendum',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {}
  },
  [ROUTINGDATA.company]: {
    title: 'Company Profile – VelaiVendum',
    description: 'Details about a specific company on VelaiVendum. Free job posting for new users. Employers can register to post jobs.',
    keywords: 'company profile, employer, job posting, VelaiVendum',
    ogImage: '/img/VVLogo_updated.jpg',
    jsonld: {}
  }
};;

// Default metadata if a route is not explicitly configured
const defaultMeta = {
  title: 'VelaiVendum – Tamil Nadu Job Portal',
  description: 'Explore job opportunities across Tamil Nadu. Free job posting for new users. Employers can register to post jobs. Apply for IT, Engineering, Freshers, Private and Government jobs.',
  keywords: 'Tamil Nadu Jobs, Jobs in Chennai, Tamil Jobs, Job Vacancies Tamil Nadu',
  ogImage: '/img/seo_default.jpg',
  jsonld: {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "https://www.velaivendum.com",
    "name": "VelaiVendum"
  }
};

const Seo = () => {
  const { pathname } = useLocation();
  // Match exact route or fallback to generic patterns
  const meta = seoConfig[pathname] ||
    (pathname.startsWith('/job/') ? seoConfig['/job/detail'] : defaultMeta);

  const canonical = `${window.location.origin}${pathname}`;

  return (
    <Helmet>
      {/* Basic Meta */}
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={meta.ogImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={meta.ogImage} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(meta.jsonld)}
      </script>
    </Helmet>
  );
};

export default Seo;
